import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { interval, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-senior-citizen-insurance',
  templateUrl: './senior-citizen-insurance.component.html',
  styleUrls: ['./senior-citizen-insurance.component.css']
})
export class SeniorCitizenInsuarnceComponent implements OnInit {

  planValue = 2000;
  errorMessage:string;
  seniorAge: string;
  //for disabling div  in production
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) {
     }

  viewData = ['In patient care coverage upto full limit of sum insured.',
    'Day Care Treatment Coverage upto full limit of sum insured',
    "Day Care Treatment Coverage upto full limit of sum insured.",
    "Cover for Hospital's ICU Room Rent Expenses.",
   " Pre-existing diseases coverage from 3rd year.",
   " Named Ailments (as defined in group care 360 product) coverage from 3rd Year.",
   " Cover for Pre-hospitalisation Medical Expenses for 30 days.",
    "Cover for Post hospitalisation Medical Expenses for 60 days.",
   ' Cover for Domestic Road Ambulance upto Rs. 3,000 per hospitalization.',
    "30 Days Waiting Period is applicable (except for injuries/accident).",
    "Free e-consultation-health service."]

  ngOnInit() {
   }

   redirectToProposalForm() {
      if(Number(this.seniorAge)>59){
        this.errorMessage = ''
         localStorage.setItem("seniorAge",this.seniorAge)
         this.router.navigate(['/senior-citizen-quote']);
      }else{
        //alert("Minimum Age should be 60")
        if(this.seniorAge)
          this.errorMessage = "Minimum Age should be 60";
        else{
          this.errorMessage = "Please Enter Age";
        }  
        setTimeout(()=>{
          this.errorMessage=''
        }, 3000)
      }
   
   }

  
}